<template>
  <v-btn flat @click="showCalendar()">
    <div class="flex-container">
      <div class="icon-container" >
      <v-icon>calendar_today</v-icon>
      </div>
      <div class="date-container" >
        <p>{{this.formatDate().startDate}} </p>
        <p v-if="this.formatDate().endDate"> - {{this.formatDate().endDate}}</p>
      </div>
    </div>
  </v-btn>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateRangePicker',
  data: () => ({
    date: null
  }),
  methods: {
    showCalendar () {
      this.$store.commit('setCalendar', true)
    },
    formatDate () {
      let endDate = moment(this.$store.state.dateRange.endDate).format('DD.MM')
      let startDate = moment(this.$store.state.dateRange.startDate).format('DD.MM')
      if (startDate === endDate) {
        return []
      }
      return {endDate, startDate}
    }
  }
}
</script>

<style scoped >
  .flex-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .date-container {
    display: flex;
    justify-content: center;
    margin-top: 2px;
  }
  .icon-container {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DateRangePicker.vue